module.exports = __webpack_public_path__ + "plot-generator/static/media/logos.99b22564.png";